import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Add Client Thunk ---
export const addClient = createAsyncThunk(
  "Client/addClient",
  async ({ values, loginData }, { rejectWithValue }) => {
    const adminId = loginData?.data?._id;
    try {
      const response = await axios.post(
        `${BaseUrl}/client_add/${adminId}`,
        values
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Unknown error");
    }
  }
);

// --- Fetch All Clients Thunk ---
export const fetchAllClients = createAsyncThunk(
  "Client/fetchAllClients",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/client_view_All`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Unknown error");
    }
  }
);

// --- Redux Slice ---
const ClientSlice = createSlice({
  name: "client",
  initialState: {
    ClientData: null,
    AddClientLoading: false,
    AddClientSuccess: false,
    AddClientError: null,

    AllClients: [],
    FetchClientsLoading: false,
    FetchClientsError: null,
  },
  reducers: {
    resetAddClientState: (state) => {
      state.AddClientLoading = false;
      state.AddClientSuccess = false;
      state.AddClientError = null;
      state.ClientData = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // --- Log Report Data ---
      .addCase(addClient.pending, (state) => {
        state.AddClientLoading = true;
        state.AddClientSuccess = false;
        state.AddClientError = null;
        state.ClientData = null;
      })
      .addCase(addClient.fulfilled, (state, action) => {
        state.AddClientLoading = false;
        state.AddClientSuccess = true;
        state.AddClientError = null;
        state.ClientData = action.payload;
      })
      .addCase(addClient.rejected, (state, action) => {
        state.AddClientLoading = false;
        state.AddClientSuccess = false;
        state.AddClientError = action.payload || "Something went wrong";
        state.ClientData = null;
      })

      // Add this for fetchAllClients
      .addCase(fetchAllClients.pending, (state) => {
        state.FetchClientsLoading = true;
        state.FetchClientsError = null;
      })
      .addCase(fetchAllClients.fulfilled, (state, action) => {
        state.FetchClientsLoading = false;
        state.AllClients = action.payload;
      })
      .addCase(fetchAllClients.rejected, (state, action) => {
        state.FetchClientsLoading = false;
        state.FetchClientsError = action.payload || "Something went wrong";
      });
  },
});

export const { resetAddClientState } = ClientSlice.actions;
// Export the reducer
export default ClientSlice.reducer;
